/**
 * @voltxampere/ui — LM337 adjustable -5V default linear regulator (Sprint 40-2)
 *
 * Negative-rail counterpart to LM317. Adjustable -1.25 to -37 V,
 * I_max 1.5 A, TO-220. Sprint 40 ships nominal -5 V; runtime R-value
 * parameter binding Sprint 42+.
 *
 * Reference: TI LM337. Engine zero-diff invariant honored —
 * canonical "voltage-source" engine type with negative voltage.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulatorLm337 = {
    id: "lm337",
    nameTr: "LM337 (Ayarlanabilir -5V, TO-220)",
    nameEn: "LM337 (Adjustable -5V, TO-220)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "LM337",
    schemaType: "voltage-source",
    defaultParams: { voltage: -5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-lm337.js.map